import { render } from "./ImageRoundedCircle.vue?vue&type=template&id=7b6e0bf8"
import script from "./ImageRoundedCircle.vue?vue&type=script&lang=js"
export * from "./ImageRoundedCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__